export const EMAIL_LOGIN_PAGE_TITLE = {
  icon: {
    id: 'email',
    fill: '#38B9FF',
    width: 36,
    height: 36,
  },
  title: '이메일로 로그인하기',
  description: '이메일과 비밀번호로 로그인해봐요',
};

export const SIGN_UP_PAGE_TITLE = {
  step1: {
    icon: {
      id: 'symbol',
      fill: '#38B9FF',
      width: 36,
      height: 36,
    },
    title: '회원가입하기',
    description: '빠르게 회원가입해봐요',
  },
  step2: {
    icon: {
      id: 'symbol',
      fill: '#38B9FF',
      width: 36,
      height: 36,
    },
    title: '회원가입하기',
    description: '이제 비밀번호를 정하기만 하면 가입 완료!',
  },
};

export const RESET_PASSWORD_PAGE_TITLE = {
  step1: {
    icon: {
      id: 'waterdrop',
      fill: '#38B9FF',
      width: 36,
      height: 36,
    },
    title: '비밀번호 재설정',
    description: '회원가입 시 사용했던 이메일을 입력해주세요',
  },
  step2: {
    icon: {
      id: 'waterdrop',
      fill: '#38B9FF',
      width: 36,
      height: 36,
    },
    title: '비밀번호 재설정',
    description: '새로 사용할 비밀번호를 입력해주세요',
  },
};
